export const loginIdRegex = new RegExp('^[a-zA-Z0-9._-]+$');
export const mobileRegex = new RegExp('^[\\d]{8,13}$');
export const mobileRegexNew = new RegExp('^[\\d]{0,13}$');
export const emailRegex = new RegExp('^(?=.{1,50}$)[a-zA-Z0-9_!#$%&*+/=?`{|}~^.-]+@[a-zA-Z0-9_-]+\\.[a-zA-Z0-9.]+$');
export const urlRegex = new RegExp(/(https?:\/\/\S+)/, 'g');
export const mobileRegexhk = new RegExp('^[\\d]{8}$');
